import { Getters } from "vuex";
import { WalletGetters, WalletState } from "./types";

export const getters: Getters<WalletState, WalletGetters> = {};
